import { Notification, NOTIFICATION_TYPE } from '../../../typings/api/models';
import { getFetch } from '../fetch';

import { apiConfig } from '../config';

interface GetNotificationRequestData {
    excludeTypes?: NOTIFICATION_TYPE[],
    includeTypes?: NOTIFICATION_TYPE[],
    page?: number;
    pageSize?: number;
}

interface GetNotificationRequestTypesParams {
    exclude_types?: NOTIFICATION_TYPE[],
    include_types?: NOTIFICATION_TYPE[],
}

interface GetNotificationsResponseData {
    count: number;
    next: number | null;
    previous: number | null;
    results: Array<Notification>;
}

export function getNotifications(request: GetNotificationRequestData = {}): Promise<GetNotificationsResponseData> {
    // @ts-ignore
    const { apiGetNotifications } = apiConfig.getStaticUrls();
    const { excludeTypes, includeTypes, page, pageSize } = request;
    const params: GetNotificationRequestTypesParams = {};

    if (excludeTypes) {
        params.exclude_types = excludeTypes;
    }

    if (includeTypes) {
        params.include_types = includeTypes;
    }

    return getFetch(apiGetNotifications, {
        ...params,
        page,
        page_size: pageSize,
    });
}
